import { env } from '../../config/env';
import type { ValidateCouponRequest, ValidateCouponResponse } from '../../types/coupon';
import * as http from './couponService.http';
import * as mock from './couponService.mock';

export interface CouponService {
  validateCoupon(request: ValidateCouponRequest): Promise<ValidateCouponResponse>;
}

const mockCouponService: CouponService = {
  validateCoupon: mock.mockValidateCoupon,
};

const httpCouponService: CouponService = {
  validateCoupon: http.httpValidateCoupon,
};

export const couponService: CouponService = env.useMock ? mockCouponService : httpCouponService;
